import type { ReactNode } from 'react';
import './ModuleSection.css';

interface Props {
  number: string;
  kicker: string;
  title: ReactNode;
  /** Plain string is rendered as a single <p>; pass a ReactNode for
   *  multi-paragraph or mixed-content intros. */
  intro: ReactNode;
  id: string;
  /** When true, the title renders at the larger billboard size — used
   *  for sections that should anchor visually as the page's headline. */
  large?: boolean;
  children: ReactNode;
}

export default function ModuleSection({
  number,
  kicker,
  title,
  intro,
  id,
  large = false,
  children,
}: Props) {
  return (
    <section className="module" id={id}>
      <div className="module__inner">
        <header className="module__header">
          <span className="module__number" aria-hidden="true">
            {number}
          </span>
          <div className="module__title-block">
            <p className="module__kicker">{kicker}</p>
            <h2 className={`module__title${large ? ' module__title--large' : ''}`}>
              {title}
            </h2>
          </div>
        </header>
        {typeof intro === 'string' ? (
          <p className="module__intro">{intro}</p>
        ) : (
          <div className="module__intro">{intro}</div>
        )}
        {children}
      </div>
    </section>
  );
}
